import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import Footer from "../../examples/Footer";
import TabComponent from "components/TabComponent";
import Button from "../../components/ButtonUse.jsx";
import axios from "axios";
import { categoryConfig } from "utils/awsCnfig";
import { baseUrl } from "utils/api";
import useSWR from "swr";
import LoaderComponent from "components/Loader";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { uploadFile } from 'react-s3';
import { useLocation } from "react-router-dom";
import { GeneralDetailsForm, DataForm, SeoForm, BodyDataForm } from "./EditCategory";

// import Button from "../../components/ButtonUse.jsx";
// Data
// Dashboard components
export function EditCategory() {
    const [loading, setLoading] = useState(false);
    const [openDialog, setOpenDialog] = useState(false);
    const handleClose = () => setOpenDialog(false);
    const [category, setCategory] = useState(null);
    const location = useLocation();
    const [categoryImage, setCategoryImage] = useState('');
    const navigate = useNavigate();
    const [showImgUpload, setShowImgUpload] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [formLoading, setFormLoading] = useState(false);
    const handleFileChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            setSelectedFile(file);
            const imageUrl = URL.createObjectURL(file);
            setPreviewUrl(imageUrl);
        }
    };


    // upload category image to s3 bucket logic-:
    const uploadCategoryImageS3 = async () => {
        try {
            if (selectedFile) {
                const { location } = await uploadFile(selectedFile, categoryConfig);
                return location;
            }

        } catch (error) {
            console.log("Error: ", error);
            throw error; // Propagate the error up
        }
    };

    //   fetch category names for select option-:
    const fetchData = async (url) => {
        try {
            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            console.log(error);
        }
    };
    const { data, error } = useSWR(`${process.env.REACT_APP_BASE_URL}/fetch/categorynames`, fetchData);

    const [bodyData, setBodyData] = useState({
        name: '',
        gender: '',
        age: "",
        height: "",
        chest: "",
        weight: "",
        shoulder: "",
        waist: "",
        hip: "",
        foot: "",
    });
    const [isBodyData, setIsBodyData] = useState('');
    console.log(data);
    const options = data;
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [formState, setFormState] = useState({
        categoryName: "",
        parent: "",
        subParent: "",
        innerParent: "",
        sortOrder: "",
        description: "",
        minimalSize: "",
        minimalWeight: "",
        deliveryByTrain: "",
        deliveryByAir: "",
        calculateShippingPriceByWeight: "",
        percentageOfProfit: "",
        metaTitle: "",
        metaTag: "",
        metaDescription: "",
        seoKeyword: "",
        pinned: false,
        subCategories: null,
        status: "",
    });
    console.log(categoryImage);
    useEffect(() => {
        console.log(location.state, 'Location')

        async function fetchCategory() {
            try {
                setLoading(true);
                
                const { data } = await axios.get(`${process.env.REACT_APP_BASE_URL}/categories/getCategoryDetailsV2?categoryId=${location.state.category._id}`);
                setLoading(false);
                console.log( data?.data["category"],'DDDATTA')
                setCategory(data?.category);
                setFormState({
                    ...formState,
                    categoryName: data?.data["category"],
                    // description: data?.category?.description,
                    // parent: data?.category?.parent,
                    // subParent: data?.category?.subParent,
                    // innerParent: data?.category?.innerParent,
                    // sortOrder: data?.category?.sortOrder,
                    minimalWeight: data?.data["Minimal weight kg"],
                    minimalSize: data?.data["Minimal size"],
                    deliveryByTrain: data?.data["Delivery by train"],
                    deliveryByAir: data?.data["Delivery by air"],
                    Profit: data?.data["Profit"],
                    showORNot:data?.data["Show or not"],
                    // calculateShippingPriceByWeight: data?.category?.calculateShippingPriceByWeight,
                    metaTitle:data?.data["Meta title"],
                    metaTag:data?.data[`"Meta tag"`],
                    metaDescription:data?.data["Meta description"],
                    categoryImage:data?.data["categoryImage"],
                    //bodyDATA
                    Chest:data?.data["Chest"],
                    Foot:data?.data["Foot"],
                    Age:data?.data["Age"],
                    Gender:data?.data["Gender"],
                    Height:data?.data["Height"],
                    Hip:data?.data["Hip"],
                    Shoulder:data?.data["Shoulder"],
                    Weight:data?.data["Weight"],
                    Waistline:data?.data["Waistline"],


                    // pinned: data?.category?.pinned,
                });
                console.log( formState,'DDDATTAFORM')

            } catch (error) {
                setLoading(false);
            }
        }
        fetchCategory();
    }, []);

    async function handleUpdateCategory(e) {
        e.preventDefault();
        // setFormLoading(true);

        try {
            // const uploadedLocation = await uploadCategoryImageS3();
            // console.log("Uploaded Location:", uploadedLocation);
                console.log(location.state, 'Location')
            const res = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/categories/updateCategoriesV2?categoryId=${location.state.category._id}`,
                
                {
                    "category":formState.categoryName,
                    "Minimal weight kg":formState.minimalWeight,
                    "Minimal size":formState.minimalSize,
                    "Delivery by train":formState.deliveryByTrain,
                    "Delivery by air":formState.deliveryByAir,
                    "Profit":formState.percentageOfProfit,
                    "Show or not":formState.showORNot,
                    "Meta title":formState.metaTitle,
                    "Meta tag":formState.metaTag,
                    "Meta description":formState.metaDescription,
                    "categoryImage":formState.categoryImage,
                    //bodyDATA
                    "Chest":formState.Chest,
                    "Foot":formState.Foot,
                    "Age":formState.Age,
                    "Gender":formState.Gender,
                    "Height":formState.Height,
                    "Hip":formState.Hip,
                    "Shoulder":formState.Shoulder,
                    "Weight":formState.Weight,
                    "Waistline":formState.Waistline,
                    // "calculateShippingPriceByWeight":formState.calculateShippingPriceByWeight,
                    // "pinned":formState.pinned,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );
            console.log(res,'responsess')

            if (res.status === 200) {
                setFormLoading(false);
                // alert("Updated category");
                // navigate("/categories");
            }
        } catch (error) {
            setFormLoading(false);
            console.error(error);
            alert("Error updating category");
        }
    }



    const tabProps = [
        {
            title: "General",
            content: (
                <GeneralDetailsForm
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                    options={options}
                    data={formState}
                    setFunc={setFormState}
                    isBodyData={isBodyData}
                    setIsBodyData={setIsBodyData} />
            ),
            id: 1,
        },
        {
            title: "Data",
            content: (
                <DataForm
                    openDialog={openDialog}
                    setOpenDialog={setOpenDialog}
                    data={formState}
                    setFunc={setFormState}
                    preview={previewUrl}
                    selectedFile={selectedFile}
                    handleChange={handleFileChange}
                    handleClose={handleClose}
                    showImgUpload={showImgUpload}
                    setShowImgUpload={setShowImgUpload} />
            ),
            id: 2,
        },
        {
            title: "SEO",
            content: <SeoForm data={formState} setFunc={setFormState} />,
            id: 3,
        },
        {
            title: formState?.showORNot == 1 ? "Body Data" : "",
            content: formState?.showORNot == '1' ? <BodyDataForm isBodyData={formState?.showORNot} setInputValues={setIsBodyData} bodyData={bodyData} setBodyData={setBodyData} data={formState} setFunc={setFormState} /> : '',
            id: 4,
        },
    ];


    const [categoryName, setCategoryName] = useState('');

    useEffect(() => {
        const storedCategoryName = localStorage.getItem('categoryName');
        if (storedCategoryName) {
            setCategoryName(JSON.parse(storedCategoryName));
        }
    }, []);

    const handleInputChange = (e) => {
        const value = e.target.value;
        setCategoryName(value);
        localStorage.setItem('categoryName', JSON.stringify(value));
    };

    return (
        <DashboardLayout>
            {loading && <LoaderComponent open={true} />}
            {formLoading && <LoaderComponent open={true} />}
            <DashboardNavbar />
            <form
                onSubmit={handleUpdateCategory}
                style={{
                    background: "white",
                    padding: "10px",
                    borderRadius: "10px",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                }}
            >
                <div style={{ display: "flex", gap: "20px", justifyContent: "end" }}>
                    <Button title={"Submit"} background={"green"} type={"submit"} />
                    <Button
                        cliclHandler={() => {
                            navigate(-1);
                        }}
                        title={"Cancel"}
                        background={"red"}
                        type={"button"} />
                </div>
                <TabComponent tabContent={tabProps} />
            </form>

            <Footer />
        </DashboardLayout>
    );
}
